import styled from 'styled-components'
import FantaTheme from '@chegg-wt/core/theme/fanta/theme'

export const BreadcrumbContainer = styled.div`
  display: flex;
  padding: ${FantaTheme.spacing.fanta.lg} ${FantaTheme.spacing.fanta.lg};
`
export const CrumbWrapper = styled.div`
  font-size: ${FantaTheme.font.text.size.sm};
`
export const CrumbLink = styled.a`
  color: ${FantaTheme.colors.grey};
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`
export const CrumbLabel = styled.span`
  color: ${FantaTheme.colors.grey};
`
export const CrumbDivider = styled.span`
  color: ${FantaTheme.colors.grey};
  padding: 0 ${FantaTheme.spacing.fanta.xxs};
`
